import {
  IArticle,
  ICreateArticle,
  IUpdateArticle,
} from "../../../models/article.ts";
import { ILazyAttachment } from "../../../models/zip_content.ts";
import { zendeskHttpRequest } from "../zendeskHttpRequest.ts";
import { CancelManager } from "../../cancelManager.ts";

const UPLOAD_CONCURRENCY = 3;

export const uploadArticleAttachments = async (
  client: any,
  brandUrl: string,
  articleId: number,
  article: ICreateArticle | IUpdateArticle,
  attachments: ILazyAttachment[],
) => {
  const cancelManager = CancelManager.getInstance();

  // 添付ファイル名からILazyAttachmentを事前に解決
  const resolvedAttachments = article.attachment_names.map((attachmentName) => {
    const attachment = attachments.find(
      (attachment) => attachment.name === attachmentName,
    );
    if (!attachment) {
      throw (
        "アップロードエラー:" +
        `添付ファイルが見つかりません(filename: ${attachmentName})`
      );
    }
    return attachment;
  });

  const results: Awaited<ReturnType<typeof uploadArticleAttachment>>[] = new Array(resolvedAttachments.length);
  let nextIndex = 0;

  const worker = async () => {
    while (nextIndex < resolvedAttachments.length) {
      cancelManager.checkCancelled();
      const idx = nextIndex++;
      results[idx] = await uploadArticleAttachment(client, brandUrl, articleId, resolvedAttachments[idx]);
      await new Promise((resolve) => setTimeout(resolve, 200));
    }
  };

  const workers = Array.from(
    { length: Math.min(UPLOAD_CONCURRENCY, resolvedAttachments.length) },
    () => worker(),
  );
  await Promise.all(workers);

  return results;
};

const uploadArticleAttachment = async (
  token: string,
  brandUrl: string,
  articleId: number,
  attachment: ILazyAttachment,
) => {
  try {
    const content = attachment.getContent();
    const blob = new Blob([content.buffer as ArrayBuffer], {
      type: "application/octet-stream",
    });
    const formData = new FormData();
    formData.append("file", blob, attachment.name);

    await zendeskHttpRequest<{ article: IArticle }>(
      `help_center/articles/${articleId}/attachments`,
      token,
      "POST",
      brandUrl,
      formData,
    );
  } catch (error) {
    throw "アップロードエラー:" + error;
  }
};
